class VimeoService {
  playBtnUrl = 'http://f.vimeocdn.com/p/images/crawler_play.png'

  getThumbnailUrl(thumbnailId: string, width: number, height: number) {
    return `https://i.vimeocdn.com/video/${thumbnailId}_${width}x${height}.jpg?r=pad`
  }

  getThmbailWithIconUrl(thumbnailId: string, width: number, height: number) {
    return `https://i.vimeocdn.com/filter/overlay?src0=${escape(this.getThumbnailUrl(thumbnailId, width, height))}&src1=${escape(this.playBtnUrl)}`
  }
}

const vimeoService = new VimeoService();
export default vimeoService;
export {VimeoService};
